import React from 'react';
import { useTranslation } from 'react-i18next';
import AzureVideo from '../../../assets/videos/Azure-academy.mp4';
import CorporateImg from '../../../assets/images/itm-academy-corporate.png';
import CorporateImg2 from '../../../assets/images/itm-academy-img.jpeg';
import './IntroSectionFormationEntra.css';

const IntroSectionFormationEntra2: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="intro-section-home intro-section-formation-entra-2">
      {/* Video and Images Sections */}
      <div className="intro-section">
        <div className="intro-row-1">
          <div className="intro-text-1">
            <h2>{t('formationEntra.sections.1.title', 'Protégez les Accès')}</h2>
            <h3>{t('formationEntra.sections.1.description', 'Cette formation premium vous permet d\'acquérir les compétences clés pour sécuriser et administrer les identités numériques dans un environnement cloud.')}</h3>
          </div>
          <div className="intro-image">
            <video
              className="intro-media"
              autoPlay
              loop
              muted
              playsInline
            >
              <source src={AzureVideo} type="video/mp4" />
              {t('formationEntra.video.fallback', 'Votre navigateur ne supporte pas la balise vidéo.')}
            </video>
          </div>
        </div>

        <div className="intro-row-2">
          <div className="intro-text-2">
            <h2>{t('formationEntra.sections.2.title', 'Sécurité et Optimisation')}</h2>
            <h3>{t('formationEntra.sections.2.description', 'Sécurisez Active Directory, synchronisez les identités avec Azure AD Connect et gérez la conformité avec Intune et Autopilot. Utilisez Azure Monitor pour suivre vos ressources, contrôlez vos dépenses avec Cost Management et optimisez la gouvernance cloud.')}</h3>
          </div>

          <div className="intro-image">
            <img
              className="intro-media"
              src={CorporateImg2}
              alt={t('formationEntra.sections.2.imgAlt', 'Security')}
            />
          </div>
        </div>

        <div className="intro-bottom-home">
          <div className="intro-row-1">
            <div className="intro-text-1">
              <h2>{t('formationEntra.sections.3.title', 'Anticipez les Menaces')}</h2>
              <h3>{t('formationEntra.sections.3.description', 'Assurez la résilience de vos infrastructures en sauvegardant Office 365, synchronisez vos fichiers, et préparez vos migrations grâce à Azure Migrate. Mettez en place des politiques de sécurité proactives, et adoptez les bonnes pratiques de gestion des identités pour renforcer la résilience de votre entreprise face aux menaces.')}</h3>
            </div>
            <div className="intro-image">
              <img
                src={CorporateImg}
                loading="lazy"
                className="intro-media"
                alt={t('formationEntra.sections.3.imgAlt', 'Formation Corporate')}
              />
            </div>
          </div>
        </div>

        <div className="intro-section-formation">
          <div className="centered-title-formation">
          </div>
        </div>
      </div>
    </div>
  );
};

export default IntroSectionFormationEntra2;
